import { IncomeTaxPersonalChildInSalaryDividendOptions } from './income-tax-personal-child-in-salary-dividend.options';
import {
  IncomeTaxPersonalSpouseInSalaryDividendOptions,
} from './income-tax-personal-spouse-in-salary-dividend.options';
import { validateIf, ValidateNested } from '@pristine-ts/class-validator';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { array } from '@pristine-ts/data-mapping-common';
import { IncomeTaxPersonalOptions } from '../../../income-tax/personal/personal/income-tax-personal.options';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import { IncomeTaxPersonalCommonOptions } from '../../../income-tax/personal/common/income-tax-personal-common.options';
import {advancedFormArray, advancedFormGroup} from "@magieno/common";

@translationBaseKey('income-tax-personal-in-salary-dividend-options')
export class IncomeTaxPersonalInSalaryDividendOptions implements Omit<IncomeTaxPersonalOptions,
  'calculationKeyname' |
  'mainPerson' |
  'spouse' |
  'children' |
  'fiscalYear'
> {

  @advancedFormGroup({
    classType: IncomeTaxPersonalSpouseInSalaryDividendOptions,
  })
  @ValidateNested()
  mainPerson: IncomeTaxPersonalSpouseInSalaryDividendOptions = new IncomeTaxPersonalSpouseInSalaryDividendOptions();

  @advancedFormGroup({
    classType: IncomeTaxPersonalSpouseInSalaryDividendOptions,
  })
  @validateIf((options: IncomeTaxPersonalInSalaryDividendOptions) => {
    return options.isMarried === true;
  })
  @ValidateNested()
  @validateIf((options, value) => options.isMarried)
  spouse?: IncomeTaxPersonalSpouseInSalaryDividendOptions;

  @array(IncomeTaxPersonalChildInSalaryDividendOptions)
  @advancedFormArray({
    emptyNumberOfChildrenFormToCreate: 0,
    elementClassType: IncomeTaxPersonalChildInSalaryDividendOptions,
  })
  @ValidateNested()
  children: IncomeTaxPersonalChildInSalaryDividendOptions[] = [];

  @clonePropertyMetadata(IncomeTaxPersonalCommonOptions, 'isCareExpensesCalculated')
  isCareExpensesCalculated: boolean;

  @clonePropertyMetadata(IncomeTaxPersonalCommonOptions, 'isMarried')
  isMarried: boolean;
}
